/*!
 * ignore
 */

'use strict';

module.exports = function() {};
